import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isNeutral: localStorage.getItem('isNeutral') === 'true',
    isCBLCustomer: localStorage.getItem('isCBLCustomer') === 'true',
    language: localStorage.getItem('language') || 'zh-CN,zh;q=0.9', // 'en;q=0.9',
    isWXMiniProgramEnv: true,
    loginUserInfor: JSON.parse(localStorage.getItem('loginUserInfor')) || {},
    showEndUseTime: localStorage.getItem('showEndUseTime') || 'ON',
    currentProjectRole: localStorage.getItem('currentProjectRole') || '',
    productParams: localStorage.getItem('productParams') === 'undefined' ? [] : JSON.parse(localStorage.getItem('productParams')),
    productParamsRemote: localStorage.getItem('productParamsRemote') === 'undefined' ? [] : JSON.parse(localStorage.getItem('productParamsRemote')),
    currentProjectId: localStorage.getItem('currentProjectId') || '',
    projectTypes: JSON.parse(localStorage.getItem('projectTypes')) || ['全部'],
    currentProjectProductType: localStorage.getItem('currentProjectProductType') || '',
    currentProjectDeviceName: localStorage.getItem('currentProjectDeviceName') || '',
    switchOff: localStorage.getItem('switchOff') || '',
    switchOn: localStorage.getItem('switchOn') || '',
    host: localStorage.getItem('host') || '',
    isTianYingV2: localStorage.getItem('isTianYingV2') === 'true' || false,
    solarModifyProject: localStorage.getItem('solarModifyProject'),
    zxyDeviceDetail: {},
    zxyDeviceList: [],
    dtuProductList: JSON.parse(localStorage.getItem('dtuProductList')) || [],
    dtuProtocolId: localStorage.getItem('dtuProtocolId'),
  },
  mutations: {
    setIsNeutral: (state, isNeutral) => {
      state.isNeutral = isNeutral
      localStorage.setItem('isNeutral', isNeutral)
    },
    setIsCBLCustomer: (state, isCBLCustomer) => {
      state.isCBLCustomer = isCBLCustomer
      localStorage.setItem('isCBLCustomer', isCBLCustomer)
    },
    setLanguage: (state, language) => {
      state.language = language
      localStorage.setItem('language', language)
    },
    setShowEndUseTime: (state, value) => {
      state.showEndUseTime = value
      localStorage.setItem('showEndUseTime', value)
    },
    setLoginUserInfor: (state, loginUserInfor) => {
      state.loginUserInfor = loginUserInfor
      localStorage.setItem('loginUserInfor', JSON.stringify(loginUserInfor))
    },
    setCurrentProjectRole: (state, currentProjectRole) => {
      state.currentProjectRole = currentProjectRole
      localStorage.setItem('currentProjectRole', currentProjectRole)
    },
    setProductParams: (state, productParams) => {
      state.productParams = productParams
      localStorage.setItem('productParams', JSON.stringify(productParams))
    },
    setProductParamsRemote: (state, productParams) => {
      state.productParamsRemote = productParams
      localStorage.setItem('productParamsRemote', JSON.stringify(productParams))
    },
    setCurrentProjectId: (state, currentProjectId) => {
      state.currentProjectId = currentProjectId
      localStorage.setItem('currentProjectId', currentProjectId)
    },
    setProjectTypes: (state, projectTypes) => {
      state.projectTypes = projectTypes
      localStorage.setItem('projectTypes', JSON.stringify(projectTypes))
    },
    setCurrentProjectDeviceName: (state, currentProjectDeviceName) => {
      state.currentProjectDeviceName = currentProjectDeviceName
      localStorage.setItem('currentProjectDeviceName', currentProjectDeviceName)
    },
    setCurrentProjectProductType: (state, currentProjectProductType) => {
      state.currentProjectProductType = currentProjectProductType
      localStorage.setItem('currentProjectProductType', currentProjectProductType)
    },
    setSwitchOff: (state, switchOff) => {
      state.switchOff = switchOff
      localStorage.setItem('switchOff', switchOff)
    },
    setSwitchOn: (state, switchOn) => {
      state.switchOn = switchOn
      localStorage.setItem('switchOn', switchOn)
    },
    setHost: (state, host) => {
      state.host = host
      localStorage.setItem('host', host)
    },
    setIsTianYingV2: (state, isTianYingV2) => {
      state.isTianYingV2 = isTianYingV2
      localStorage.setItem('isTianYingV2', isTianYingV2)
    },
    setSolarModifyProject: (state, playload) => {
      state.solarModifyProject = playload
      localStorage.setItem('solarModifyProject', playload)
    },
    setZxyDeviceDetail: (state, playload) => {
      state.zxyDeviceDetail = playload
    },
    setZxyDeviceList: (state, playload) => {
      state.zxyDeviceList = playload
    },
    setDtuProductList: (state, playload) => {
      state.dtuProductList = playload
      localStorage.setItem('dtuProductList', JSON.stringify(playload))
    },
    setDtuProtocolId: (state, playload) => {
      state.dtuProtocolId = playload
      localStorage.setItem('dtuProtocolId', playload)
    }
  },
  getters: {
  },
  actions: {
    commitProductParams: ({commit}, productParams) => {
      commit('setProductParams', productParams)
    },
    commitProductParamsRemote: ({commit}, productParams) => {
      commit('setProductParamsRemote', productParams)
    },
    commitCurrentProjectRole: ({commit}, currentProjectRole) => {
      commit('setCurrentProjectRole', currentProjectRole)
    },
    commitCurrentProjectId: ({commit}, currentProjectId) => {
      commit('setCurrentProjectId', currentProjectId)
    },
    commitProjectTypes: ({commit}, projectTypes) => {
      commit('setProjectTypes', projectTypes)
    },
    commitCurrentProjectDeviceName: ({commit}, currentProjectDeviceName) => {
      commit('setCurrentProjectDeviceName', currentProjectDeviceName)
    },
    commitCurrentProjectProductType: ({commit}, currentProjectProductType) => {
      commit('setCurrentProjectProductType', currentProjectProductType)
    },
    commitSwitchOff: ({commit}, switchOff) => {
      commit('setSwitchOff', switchOff)
    },
    commitSwitchOn: ({commit}, switchOn) => {
      commit('setSwitchOn', switchOn)
    },
    commitHost: ({commit}, host) => {
      commit('setHost', host)
    },
    commitIsTianYingV2: ({commit}, isTianYingV2) => {
      commit('setIsTianYingV2', isTianYingV2)
    }
  }
})
